import { Dao } from '../../dao';
import {
  IGizmo,
  IGizmoAncestor,
  IGizmoCallbacks,
  IGizmoEvent,
  IPlatformCallbacks,
  TGizmoOperation,
} from '../../types';

interface IParams {
  operation: TGizmoOperation;
  params?: {
    path?: string;
    fid?: string;
    rgfid?: string;
    id?: string;
    key?: string;
  };
  // TODO: we should type the paramaters correctly
  // params?: any;
  context: {
    config: IGizmo;
    callbacks: IGizmoCallbacks;
    ancestors: IGizmoAncestor[];
    platformCallbacks?: IPlatformCallbacks;
    dao?: Dao;
  };
}

/**
 * Used by Gizmos to dispatch an operation and notify the RootGizmo via a GizmoEvent
 *
 * @param {IGizmoOperation} operation operation being dispatched by a Gizmo
 * @returns
 */
function dispatchGizmoOperation({
  operation,
  params,
  context,
}: IParams): Promise<any> {
  return new Promise<any>(async resolve => {
    const { ancestors, config, callbacks, dao, platformCallbacks } = context;

    if (
      operation === 'form.submit' ||
      operation === 'form.cancel' ||
      operation === 'auth.logout'
    ) {
      const event: IGizmoEvent = {
        type: 'gizmo.operation',
        src: {
          type: 'gizmo',
          gizmoUid: config.uid,
          gizmoFid: config.fid,
        },
        data: {
          gizmoOperation: {
            operation,
          },
        },
      };

      await callbacks.sendEventCB({ event });
    } else if (
      operation === 'navigation.link' &&
      platformCallbacks &&
      config.ops?.button?.navigation?.path
    ) {
      await platformCallbacks.platformOperationCB({
        operation,
        params: {
          path: config.ops.button.navigation.path,
        },
      });
    } else if (
      operation === 'navigation.link' &&
      platformCallbacks &&
      params?.path
    ) {
      await platformCallbacks.platformOperationCB({
        operation,
        params: {
          path: params.path,
        },
      });
    } else if (operation === 'export.download' && params?.fid && dao) {
      return resolve(
        await dao.getBatchIndex({
          fid: params.fid,
        })
      );
    } else if (
      operation === 'pdf.download' &&
      dao &&
      params?.rgfid &&
      params.id
    ) {
      return resolve(
        await dao.getRootGizmoDataPdf({
          rgfid: params.rgfid,
          id: params.id,
        })
      );
    } else if (operation === 'section.next' || operation === 'section.back') {
      const event: IGizmoEvent = {
        type: 'platform-operation',
        src: {
          type: 'gizmo',
          gizmoUid: config.uid,
          gizmoFid: config.fid,
        },
        data: {
          platformOperation: {
            operation,
            ancestors,
          },
        },
      };

      await callbacks.sendEventCB({ event });
    } else if (operation === 'keyboard.key' && params?.key === 'enter') {
      const event: IGizmoEvent = {
        type: 'platform-operation',
        src: {
          type: 'gizmo',
          gizmoUid: config.uid,
          gizmoFid: config.fid,
        },
        data: {
          platformOperation: {
            operation,
            ancestors,
            key: params.key,
          },
        },
      };

      await callbacks.sendEventCB({ event });
    }

    resolve(undefined);
  });
}

export default dispatchGizmoOperation;
